import { api } from './index';

const ManufacturersRequestService = {
    getAll: async() => {
        return await api.get('manufacturer-request');
    },
    getAllExport: async(params) => {
        return await api.get('company-request-export',params);
    },
    getResale: async(id) => {
        return await api.get('company-request/'+id);
    },
    saveResale: async(id,form) => {
        return await api.put('company-request/'+id,form);
    },
    getInfoResale: async() => {
        return await api.get('company-request/info-form');
    },
    getResaleContacts: async(id) => {
        return await api.get('company-request/contacts/'+id);
    },
    updateResaleContacts: async(id,form) => {
        return await api.put('company-request/contacts/'+id,form);
    },
    getResaleBUs: async(id) => {
        return await api.get('company-request/bus/'+id);
    },
    updateResaleBUs: async(id,form) => {
        return await api.put('company-request/bus/'+id,form);
    },
    getResaleAttendance: async(id,params) => {
        return await api.get('company-request/attendance/'+id,params);
    },
    getResaleBrands: async(id,params) => {
        return await api.get('company-request/brands/'+id,params);
    },
    getResaleLeadHistory: async(id,params) => {
        return await api.get('company-request/lead-history/'+id,params);
    },

};

export default ManufacturersRequestService;